import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { truncatedRange } from '@rivethealth/data/truncated-range';
import { ObservableInput } from 'observable-input';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

const PAGE_INDEX_PAD = 4;

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'pages',
  styleUrls: ['./pages.component.scss'],
  templateUrl: './pages.component.html',
})
export class PagesComponent {
  @Input()
  @ObservableInput()
  count!: Observable<number>;

  @Input()
  @ObservableInput()
  current!: Observable<number>;

  readonly pages = combineLatest([this.count, this.current]).pipe(
    map(([count, current]) =>
      truncatedRange(current, count - 1, PAGE_INDEX_PAD),
    ),
  );

  @Output() readonly currentChange = new EventEmitter<number>();
}
